export { CategoriesBreadCrumbsDesktop } from './categories-page/ui/breadcrumbs';
export { CategoriesContentDesktop } from './categories-page/ui/content';
export { CategoriesWidget } from './main-page/ui';
